import React from 'react'
import imgIcon from '../../../assets/images/logo.svg'
import './Install.less'

export default function Install() {
	if (!/iPad|iPhone/.test(navigator.userAgent)) {
		return null
	}

	return (
		<div className="install-bar">
			<div className="left">
				<img className="logo" src={imgIcon} alt="Sendpoll" />
			</div>
			<div className="text">
				<div className="title">Sendpoll</div>
				<div className="body">Install to your home screen</div>
			</div>
			<div className="right">
				<a className="btn btn-default" href="#install">Install</a>
			</div>
		</div>
	)
}



// WEBPACK FOOTER //
// ./src/components/main/install/Install.jsx